import BpkImage from '@skyscanner/backpack-web/bpk-component-image';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../contexts/i18n';

import PlayButton from './imgs/play_button.png';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './PlayOverlay.module.scss';

const cls = cssModules(STYLES);

type Props = {
  onClick?: any;
  className?: string;
  i18n: I18nService;
};

const PlayOverlay = ({ className, i18n, onClick }: Props) => {
  const content = (
    <div className={cls('PlayOverlay__content')}>
      <BpkImage
        className={STYLES.PlayOverlay__img}
        src={PlayButton}
        aspectRatio={1}
        altText=""
      />
    </div>
  );

  if (onClick) {
    return (
      <button
        className={cls('PlayOverlay', className)}
        onClick={onClick}
        type="button"
        tabIndex={-1}
        aria-label={i18n.translate('ktxt_hotel_image_video')}
      >
        {content}
      </button>
    );
  }

  return <div className={cls('PlayOverlay', className)}>{content}</div>;
};

export default withI18n(PlayOverlay);
